import { useEffect } from 'react';
import { useUser } from '@poplar/hooks/useUser';
import { useAblyContext } from './useAblyContext';
export var useAblyEvents = function useAblyEvents(eventHandlers) {
  var eventPublisher = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'rep';

  var _useAblyContext = useAblyContext(),
      data = _useAblyContext.data;

  var _useUser = useUser(),
      profile = _useUser.profile;

  var userId = profile === null || profile === void 0 ? void 0 : profile.userId;
  useEffect(function () {
    if (data) {
      var eventHandler = eventHandlers[data.type];

      if (eventHandler) {
        var _data$clientId, _data$clientId2;

        // Need to use includes because the event clientId may be "agent:00fgr5g4f5g", "00fgr5g4f5g" or something else
        var isRepEvent = userId && !((_data$clientId = data.clientId) !== null && _data$clientId !== void 0 && _data$clientId.includes(userId));
        var isUserEvent = userId && ((_data$clientId2 = data.clientId) === null || _data$clientId2 === void 0 ? void 0 : _data$clientId2.includes(userId));

        if (eventPublisher === 'all' || eventPublisher === 'both' && (isRepEvent || isUserEvent) || eventPublisher === 'user' && isUserEvent && !isRepEvent || eventPublisher === 'rep' && isRepEvent) {
          eventHandler(data, eventPublisher);
        }
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [data]);
};